import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/apiClient";
import { Globe2, UserPlus } from "lucide-react";

export default function Join() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", business_name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(f);
      nav("/network");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const field = "w-full bg-black/50 border border-white/10 px-4 py-3 text-bone focus:outline-none focus:border-gold/50";
  const lbl = "text-xs uppercase tracking-widest text-bone/60 mb-2 block";

  return (
    <main className="bg-onyx min-h-screen pt-16 flex items-center grain" data-testid="join-page">
      <div className="max-w-md mx-auto w-full px-5 py-16">
        <div className="text-center mb-8">
          <Globe2 className="text-gold mx-auto mb-4" size={40} strokeWidth={1.5} />
          <h1 className="font-serif text-4xl text-bone">Join the Network</h1>
          <p className="text-bone/50 mt-2">Register your business to post opportunities and connect across the Diaspora.</p>
        </div>
        <form onSubmit={submit} className="bg-surface border border-white/10 p-8 space-y-5" data-testid="join-form">
          <div><label className={lbl}>Your Name</label><input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={field} data-testid="join-name" /></div>
          <div><label className={lbl}>Business / Organization</label><input value={f.business_name} onChange={(e) => setF({ ...f, business_name: e.target.value })} className={field} data-testid="join-business" /></div>
          <div><label className={lbl}>Email</label><input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={field} data-testid="join-email" /></div>
          <div><label className={lbl}>Password</label><input required type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className={field} data-testid="join-password" /></div>
          {error && <p className="text-red-400 text-sm" data-testid="join-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="join-submit" className="w-full bg-gold text-black py-3 font-medium hover:bg-gold2 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            <UserPlus size={16} /> {loading ? "Creating account..." : "Create Account"}
          </button>
          <p className="text-center text-bone/50 text-sm">Already registered? <Link to="/login" className="text-gold hover:underline">Sign in</Link></p>
        </form>
      </div>
    </main>
  );
}
